import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/authentication.service';
import { DynamicFirebaseService } from 'src/app/core/services/dynamic-firebase.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-validate-session',
  templateUrl: './validate-session.component.html',
  styleUrls: ['./validate-session.component.scss']
})
export class ValidateSessionComponent implements OnInit {
  public type: string = '';
  constructor(
    private router: Router,
    private authService: AuthService,
    private dynamicService: DynamicFirebaseService,
    private dialogService: MatDialog
  ) { 
    this.type = history.state['type'];
  }

  ngOnInit() {
    this.validateAndRedirect();
  }

  private async validateAndRedirect() {
    try {
      if (!this.type) return this.router.navigate(['/home']);;
      let companyId = StorageService.checkStorage().getItem('_companyId');
      if (this.type === 'login' && companyId) this.router.navigate(['/home']);
      else if(this.type === 'logout') this.attemptLogout();
    } catch (error) {
      console.error("error validate credentials", error)
      this.attemptLogout();
    }
  }

  private async attemptLogout(){
    this.dialogService.closeAll();
    if (this.authService && !this.authService.sessionActive()) return this.router.navigate(['/home']);
    const response = await this.authService.attemptLogout();
    if (!response) return this.router.navigate(['/home']);
    try {
      await this.dynamicService.deleteAllFirebaseInstances();
    } catch { }
  }
  
}
